import React, { useState, useRef } from 'react';
import Button from 'components/global/button';
import AutoComplete from 'components/global/googleAutocomplete';

const Address = ({ fields = {}, setField, nextStep, previousStep }) => {
  const { address = '', city, state, postalCode } = fields;
  const inputRef = useRef(null);

  const [isAutocomplete, setIsAutocomplete] = useState(false);
  const [enabled, setEnabled] = useState(true);

  const onFieldStatus = (state) => {
    setEnabled(state);
  };

  const usedAutocomplete = (state) => {
    setIsAutocomplete(state);
  };

  const checkFields = () => {
    if (address && !city && !state && !postalCode) {
      setField('street', address);
      setField('city', '');
      setField('state', '');
      setField('postalCode', '');
    }
  };

  const onSubmit = () => {
    const inputValue = inputRef.current?.value;
    if (inputValue) {
      checkFields();
      onFieldStatus(true);
      nextStep();
    } else {
      onFieldStatus(false);
    }
  };

  const onBack = () => {
    previousStep();
  };

  return (
    <div className="report-form">
      <h1 className="title">Where are you looking to buy?</h1>
      <div className='input-wrapper'>
        <AutoComplete
          ref={inputRef}
          placeholder={'Enter a Zip, Neighborhood or City'}
          setField={setField}
          enabledField={enabled}
          onFieldStatus={onFieldStatus}
          checkFields={checkFields}
          usedAutocomplete={usedAutocomplete}
          geoType={['postal_code', 'neighborhood', 'locality', 'administrative_area_level_2', 'administrative_area_level_3']}
        />
      </div>
      
      <Button
        text={'Next'}
        classes={'cta-filled'}
        onClick={onSubmit}
        dataCY="search_cta"
      />
      <Button
        text="Back"
        onClick={onBack}
        classes="back-button"
      />
    </div>
  );
};

export default Address;
